import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { newAncillariesConstants } from '../../../../../ib-web-new-ancillaries-constants';
import { IbDisruptedSeatsModel } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-model';
import { IbDisruptedSeatsSegmentModel } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-segment';
import { IbDisruptedSeatsRefundModel } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-refund-model';

@Injectable({
    providedIn: 'root'
})
export class IbDisruptedSeatsService {

    disruptedSeatsSegmentsMock: IbDisruptedSeatsSegmentModel = {
        disruptedSegments:[
            {
                segmentId: 'IB010520250111',
                available: false
            },
            {
                segmentId: 'IB041320250213',
                available: true
            }
        ]
    };

    disruptedSeatsRefundInfoMock: IbDisruptedSeatsRefundModel = {
        data: {
            currency: {
                code: 'EUR',
                description: 'EURO',
                symbol: '€',
                alignment: 'RIGHT',
                groupingSeparator: '.',
                decimalSeparator: ',',
                decimals: 2,
                recommendedDisplay: 'CODE',
                roundingPolicy: 'UP'
            },
            refundsMethods: [
                {
                    type: 'CASH',
                    total: 12.40,
                    currency: 'EUR'
                },
                {
                    type: 'VOUCHER',
                    total: 12.40,
                    currency: 'EUR',
                    percentage: 10,
                    extraAmount:1.24,
                    baseAmount: 12.40,
                    usageDateLimit: '2020-12-24',
                    daysToFlightAfterUse: 360
                }
            ],
            seatSegments: [{
                departureCity: 'London',
                departureAirport: 'LHR',
                arrivalCity: 'Madrid',
                arrivalAirport: 'MAD',
                total: {
                    amount: 12.40,
                    currency: 'EUR'
                },
                seats:[
                    {
                        emdNumbers:['075230239024'],
                        unitPrice: 8.40,
                        total: 8.40,
                        currency:'EUR',
                        quantity: 1
                    },
                    {
                        emdNumbers:['075230239025', '075230239026'],
                        unitPrice: 2.00,
                        total: 4.00,
                        currency:'EUR',
                        quantity: 2
                    }
                ]
            },
            {
                departureCity: 'London',
                departureAirport: 'LHR',
                arrivalCity: 'Madrid',
                arrivalAirport: 'MAD',
                total: {
                    amount: 12.40,
                    currency: 'EUR'
                },
                seats:[
                    {
                        emdNumbers:['075230239024'],
                        unitPrice: 8.40,
                        total: 8.40,
                        currency:'EUR',
                        quantity: 1
                    },
                    {
                        emdNumbers:['075230239025', '075230239026'],
                        unitPrice: 2.00,
                        total: 4.00,
                        currency:'EUR',
                        quantity: 2
                    }
                ]
            }],
            totalRefund: {
                amount: 12.40,
                currency: 'EUR'
            }
        }
    };


    constructor (
        private http: HttpClient
    ) { }

    getDisruptedSeatsData (flowId: string, creationDate: string): Observable<IbDisruptedSeatsModel> {
        return this.http.get<IbDisruptedSeatsModel>(newAncillariesConstants.DEFAULT_ENDPOINTS.disruptionSeatsDataURI + flowId + '/' + creationDate);
    }

    acceptDisruptedSeatsChanges (flowId: string): Observable<IbDisruptedSeatsModel> {
        return this.http.get<IbDisruptedSeatsModel>(newAncillariesConstants.DEFAULT_ENDPOINTS.disruptionSeatsAcceptChangesURI.replace('{flowId}', flowId));
    }

    getDisruptedSeatsSegments (flowId: string): Observable<IbDisruptedSeatsSegmentModel> {
        // return of(this.disruptedSeatsSegmentsMock);
        return this.http.get<IbDisruptedSeatsSegmentModel>(newAncillariesConstants.DEFAULT_ENDPOINTS.disruptionSeatsSegmentsDataURI + flowId);
    }

    getDisruptedSeatsRefundInfo (flowId: string, creationDate: string): Observable<IbDisruptedSeatsRefundModel> {
        // return of(this.disruptedSeatsRefundInfoMock);
        return this.http.get<IbDisruptedSeatsRefundModel>(newAncillariesConstants.DEFAULT_ENDPOINTS.disruptionSeatsRefundURI + flowId + '/' + creationDate);
    }
}
